import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { Document } from "../Model/Document";

export async function getDocument(idClassName, className) {
    // Preferir endpoint por query (compatible con vistas nuevas)
    let response = await getAPIResponse(`/v1/document?className=${className}&idClassName=${idClassName}`);
    if (response === null) {
        return null;
    }
    let documents = [];
    response.forEach((responseData) => {
        documents.push(Document.createFromResponseData(responseData));
    });
    return documents;
}